const getPlaceInfoByID = (id, placeInfoRef, requestFields, callback) => {
  if (id) {
    let service = new google.maps.places.PlacesService(placeInfoRef);
    service.getDetails({
      placeId: id,
      fields: requestFields
    }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        callback(place);
      }
    });
  }
};
export const getPlaceInfoByIDPromise = (id, placeInfoRef) => {
  return id ? new Promise((resolve, reject) => {
    let service = new google.maps.places.PlacesService(placeInfoRef);
    service.getDetails({
      placeId: id
    }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(place);
      } else {
        reject(place);
      }
    });
  }) : Promise.resolve();
};
export default getPlaceInfoByID;
export const getPlaceInfoByIDWithoutMap = (id, requestFields, callback) => {
  if (id) {
    let map = new google.maps.Map(document.createElement('div'));
    let service = new google.maps.places.PlacesService(map);
    service.getDetails({
      placeId: id,
      fields: requestFields
    }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        callback(place);
      }
    });
  }
};